var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"error"},[_c('lottie',{staticClass:"lottie",attrs:{"options":_vm.defaultOptions,"animCreated":_vm.handleAnimation}})],1),_c('br'),_c('a',{attrs:{"href":"/"}},[_vm._v("GO HOME")])])}
var staticRenderFns = []

export { render, staticRenderFns }